import React from 'react';
import Modal from 'components/Modal';
import Form from 'components/ChangePassewordModal/Form';
import { StyledLongBody } from 'components/ChangePassewordModal/styles';
import { get } from 'lodash';
import { translate } from 'helpers/intl';
import { injectIntl, IntlShape } from 'react-intl';
import messages from 'components/ChangePassewordModal/messages';

const ChangePassewordModal = (props: ChangePasswordModalType) => {
  const { isOpen, closeAddNewContractModal } = props;
  return (
    <Modal
      open={isOpen}
      handleClose={closeAddNewContractModal}
      header={
        <StyledLongBody weight="500" color="#04336B">
          {translate(get(messages, 'title'), props)}
        </StyledLongBody>
      }
      content={
        <Form
          changePassword={props.changePassword}
          handleClose={closeAddNewContractModal}
          isLoading={props.isLoading}
        />
      }
    />
  );
};

interface ChangePasswordModalType {
  isOpen: boolean;
  intl: IntlShape;
  closeAddNewContractModal: Function;
  changePassword: Function;
  isLoading: boolean;
}

export default injectIntl(ChangePassewordModal);
